import { render, staticRenderFns } from "./setupDocument.vue?vue&type=template&id=4d6f07a9"
import script from "./setupDocument.vue?vue&type=script&lang=js"
export * from "./setupDocument.vue?vue&type=script&lang=js"
import style0 from "./setupDocument.vue?vue&type=style&index=0&id=4d6f07a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports